<template>
  <div class="contact-box" :class="config?config.layout:''" ref="hostElement">
    <contact-box v-if="isReady"></contact-box>
    <div class="contact-blocker" v-if="!isReady"><div class="loader"></div></div>
  </div>
</template>

<script>
import ContactBox from './components/ContactBox.vue';
import { Labels, Config, Utils, State, DataLayer, ServiceManager } from "./services";
import { ref } from "vue";

export default {
  name: 'ContactBoxApp',
  components: {
    ContactBox
    
  },
  data () {
    return {
      labels: null,
      dataLayer: null,
      config: null,
      utils: null,
      state: null,
      isReady: false,
      isSubmitting: false
    }
  },
  setup() {
    const hostElement = ref(null);
    const uniqueId = Date.now().toString(36) + Math.random().toString(36).substring(2);
    return {
      hostElement,
      uniqueId
    }
  },
  created () {
    this.initServices();
  },
  mounted () {
    this.config.init(this.hostElement.parentNode);
    this.state.init();
    this.loadInitialState();
    this.labels.init(this.hostElement.parentNode).then(res => {
      if (this.$refs.wizard) this.$refs.wizard.$forceUpdate(); //we reload the wizard once we get the latest labels.
    }).catch(err => {
      this.utils.showStatusMessage(`Could not load labels. Error: ${err.message}.`, "red");
    });
  },
  methods: {
    initServices() {
      this.config = new Config();
      this.state = new State(this.config);
      this.utils = new Utils(this.state);
      this.dataLayer = new DataLayer(this.config, this.state, this.utils);
      this.labels = new Labels(this.dataLayer, this.config);
      
      ServiceManager.addService(this, "Config", this.config);
      ServiceManager.addService(this, "Labels", this.labels);
      ServiceManager.addService(this, "DataLayer", this.dataLayer);
      ServiceManager.addService(this, "Utils", this.utils);
      ServiceManager.addService(this, "State", this.state);
    },
    loadInitialState() {
      this.state.current.bu = this.utils.toShortId(this.config.buId);
      this.state.current.bl = this.utils.toShortId(this.config.blId);
      this.state.current.tag = this.utils.toShortId(this.utils.contactTagId);
      this.state.current.currentPage = this.utils.toShortId(this.utils.getPageProperty("hidCurrentPageId"));
      if (this.utils.getPageProperty("hidProductName")) {
        //this is a product page
        this.state.current.currentProduct = this.state.current.currentPage;
      }
      this.state.current.country = this.utils.toShortId(this.utils.getCookie("CLACountry") || Config.defaultCountry);
      this.state.current.region = this.utils.toShortId(this.utils.getCookie("CLARegion") || Config.defaultRegion);
      console.log(`Current country: ${this.state.current.country}.`);
      console.log(`Current region: ${this.state.current.region}.`);
      let taxonomyPromise = this.dataLayer.loadTaxonomy();
      taxonomyPromise.then(res => {
        this.initTaxonomyMap(res.data);
      }).catch(err => {
        this.utils.showStatusMessage(`Could not load taxonomy. Error: ${err.message}.`, "red");
      });
      let blPromise = this.dataLayer.loadOrgUnits();
      blPromise.then(res => {
        this.state.current.blParents = res.data;
      }).catch(err => {
        this.utils.showStatusMessage(`Could not load the organizational unit structure. Error: ${err.message}.`, "red");
      });

      Promise.all([taxonomyPromise, blPromise]).finally(() => {
        this.isReady = true;
        this.state.current.isReady = true;
      });
    },
    initTaxonomyMap(data) {
      if (!data) return;
      this.state.current.taxonomy = data;
    }
  }
}
</script>

<style scoped>
.contact-box {
  position: relative;
}

.contact-box.vertical {
  min-height: 239px;
}

/* we set explicit heights, trying to avoid layout shuffling */
.contact-box.horizontal {
  min-height: 102px;
}

.contact-box.inline {
  min-height: 746px;
}

.contact-box.inline.ics {
  min-height: 886px;
}

.contact-box > .contact-blocker {
   border: 1px solid #c9c9c9;
}
</style>
